module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-datetime-selector",
    staticStyle: {
      "padding-top": "45px"
    }
  }, [_c('mt-button', {
    on: {
      "click": _vm.handlerClear
    }
  }, [_vm._v("清空")]), _vm._v(" "), _c('mt-cell-group', [_c('mt-datetime-selector', {
    attrs: {
      "label": "日期时间",
      "placeholder": "请输入发生时间",
      "type": "datetime",
      "value": "2017-08-02 09:01:01"
    }
  }), _vm._v(" "), _c('mt-datetime-selector', {
    attrs: {
      "label": "日期时间",
      "placeholder": "限制日期选择区间",
      "type": "datetime",
      "min-date": new Date(),
      "max-date": new Date()
    },
    model: {
      value: (_vm.current),
      callback: function($$v) {
        _vm.current = $$v
      },
      expression: "current"
    }
  }), _vm._v(" "), _c('mt-datetime-selector', {
    attrs: {
      "label": "时间",
      "placeholder": "限制时间选择区间",
      "type": "time",
      "min-hour": 10,
      "max-hour": 15
    }
  })], 1), _vm._v(" "), _c('mt-cell-group', [_c('mt-datetime-selector', {
    attrs: {
      "label": "日期",
      "placeholder": "请输入生日",
      "type": "date"
    }
  }), _vm._v(" "), _c('mt-datetime-selector', {
    attrs: {
      "label": "时间",
      "placeholder": "请输入时间",
      "type": "time"
    }
  })], 1), _vm._v(" "), _c('mt-cell-group', [_c('mt-datetime-selector', {
    attrs: {
      "label": "日期",
      "placeholder": "只读",
      "type": "date",
      "readonly": ""
    }
  }), _vm._v(" "), _c('mt-datetime-selector', {
    attrs: {
      "label": "日期",
      "placeholder": "禁用",
      "type": "date",
      "disabled": ""
    }
  }), _vm._v(" "), _c('mt-datetime-selector', {
    attrs: {
      "label": "日期",
      "placeholder": "没有清除按钮",
      "type": "date",
      "disable-clear": true
    }
  }), _vm._v(" "), _c('mt-datetime-selector', {
    attrs: {
      "label": "日期",
      "placeholder": "成功",
      "type": "date",
      "state": "success"
    }
  }), _vm._v(" "), _c('mt-datetime-selector', {
    attrs: {
      "label": "日期",
      "placeholder": "错误",
      "type": "date",
      "state": "error"
    }
  }), _vm._v(" "), _c('mt-datetime-selector', {
    attrs: {
      "label": "日期",
      "placeholder": "警告",
      "type": "date",
      "state": "warning"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57d71f24","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/datetime-selector.vue
// module id = 494
// module chunks = 0